import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import { currentLang } from '../../../utils/functions';

const STORAGE_KEY = 'noticeBannerDismissed_de_farmshop';

const NoticeBanner = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [isVisible, setIsVisible] = useState(true);
  const lang = currentLang();
  const normalizedPath = pathname.replace(/\/$/, '') || '/';

  // NL homepage only (`/nl`)
  const isNlHome = lang === 'nl' && normalizedPath === '/nl';
  // Disabled no phone support banner as we are offering phone support again
  const isNlVragen = false; //lang === 'nl' && normalizedPath === '/nl/vragen';
  const isNlNooitMeerSupermarktVlees =
    lang === 'nl' && normalizedPath === '/nl/nooit-meer-supermarkt-vlees';
  const isNlBoerderijBox =
    lang === 'nl' && normalizedPath === '/nl/boerderij-box';
  // DISABLED!!! DO NOT ENABLE WITHOUT CHECKING WITH KHALIL OR ANNA
  const isDeFarmshop = false; // = lang === 'de' && pathname.startsWith('/de/farmbox');
  const shouldShowBanner = isNlHome || isNlVragen || isNlNooitMeerSupermarktVlees || isNlBoerderijBox;
  const bannerTextKey = isNlVragen
    ? 'notice_banner.phone_off'
    : isNlBoerderijBox
      ? 'notice_banner.farmshop'
      : 'notice_banner.text';

  // Call all hooks unconditionally (React rules of hooks)
  useEffect(() => {
    if (!isDeFarmshop) return;
    try {
      if (localStorage.getItem(STORAGE_KEY) === 'true') {
        setIsVisible(false);
      }
    } catch (e) {
      // ignore storage errors
    }
  }, [isDeFarmshop]);

  const handleClose = () => {
    setIsVisible(false);
    if (isDeFarmshop) {
      try {
        localStorage.setItem(STORAGE_KEY, 'true');
      } catch (e) {
        // ignore
      }
    }
  };

  // Early returns only after all hooks have been called
  if (!shouldShowBanner) {
    return null;
  }
  if (!isVisible) {
    return null;
  }

  return (
    <div className="notice-banner">
      <div className="container">
        <div className="notice-banner__content">
          <div className="notice-banner__text">
            {lang === 'de' && (
              <span className="notice-banner__icon" aria-hidden="true">
                <i className="icon-gift-fill" />
              </span>
            )}
            <span className="notice-banner__text-inner">
              {parse(t(bannerTextKey))}
            </span>
          </div>
          <button
            className="notice-banner__close"
            onClick={handleClose}
            aria-label="Schließen"
          >
            <span>&times;</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default NoticeBanner;
